import React, {useRef} from "react";

import { 
    Layout, 
    Typography, 
    Tooltip, 
    Button, 
    Space, 
    Row, 
    Col
} from 'antd';
import "./index.css"
import useWindowDimensions from "../../components/useWindowDemision";
import image_default from '../../assets/images/image_default.png';
import btn_close from '../../assets/images/btn_close.png';
import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';

import 'react-multi-carousel/lib/styles.css';

const { Paragraph } = Typography;

const ContentScans =({
    dataSelectScanned,
    setCountTooltipMinus,
    setCountTooltipAdd,
    deleteItemProduct
})=>{
    
    const valueContentScan = Array.from(new Set(dataSelectScanned));
    const { Content } = Layout;
    const { width } = useWindowDimensions();
    const messageRef = useRef();

    const toolTipBodyStyle={
        width:100, 
        height:35, 
        borderRadius:20,
        display: 'flex',
        justifyContent:'center',
        alignItems:'center',
        // backgroundColor: 'green'
    }
    const toolTipBtnStyle={
        width: 50, 
        height:80, 
        display: 'flex',
        alignItems:'center',
        justifyContent:'center'
    }
    const styleContentBody={
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
    }
    const bgListScaner={
        width: width-20, 
        height: 110, 
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex'
    }
    const styleRow={
        width:'100%',
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'flex-start'
    }
    const imgStyle={
        width: 100, 
        height: '100%', 
        display: 'flex',
        alignItems: 'center', 
        justifyContent: 'center',
    }
    const styleCol={
        justifyContent:'center', 
        alignItems:'center', 
        display: 'flex', 
        height:110, 
        flexDirection: 'column',
    }
    const bodyBtn={
        width:22, 
        height:22, 
        borderRadius:11,
        backgroundColor:'#CCCCCC',
        display: 'flex',
        justifyContent: 'center', 
        alignItems: 'center'
    }
    const styleText={
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 900,
        fontSize: 18,
        marginTop: 10
    }
    const buttonStyle={
        borderColor:'#09D3B7', 
        justifyContent: 'center', 
        alignItems: 'center', 
        display: 'flex'
    }
   
    const contentBodyListHorizontal =(item, index)=>{

        const customPop =()=>{
            return ( 
                <div style={toolTipBodyStyle}>
                    <Row>
                        <Col span={6} style={toolTipBtnStyle}>
                            <Button  
                                type="text"  
                                size="large"
                                icon={
                                    item.count === 1? null:
                                    <MinusCircleOutlined 
                                        style={{fontSize:28, color:"#09D3B7"}}
                                    />
                                }
                                onClick={()=> setCountTooltipMinus(item.jan_code)}
                            />
                        </Col>

                        <Col span={12} style={toolTipBtnStyle}>
                            <h6 style={styleText}>{item.count}</h6> 
                        </Col>

                        <Col span={6} style={toolTipBtnStyle}>
                            <Button  
                                type="text" 
                                size="large"
                                icon={
                                    <PlusCircleOutlined 
                                        style={{fontSize:28, color:"#09D3B7"}}
                                    />
                                }
                                onClick={()=>setCountTooltipAdd(item.jan_code)}
                            />
                        </Col>
                    </Row>
                </div>
            )
        }

        return (
            <div key={index}  className="bg-list">
                <div className="bg-list-scanned" style={bgListScaner}>
                    <Row style={styleRow}>

                        <Col span={6} style={imgStyle}>
                            <img 
                                src={item?.image_url? item?.image_url : image_default} 
                                width="80" height="80" 
                                alt="imagePrd"
                            />
                        </Col>

                        <Col span={14}>
                            <div style={{flexDirection:'column', padding:5,marginLeft: 0}}>
                                <h6 className="text-title-scanned">バーコード:{item?.jan_code? item?.jan_code: ''}</h6>
                                {(item?.product_name && item.isSubmit !== false)?
                                    <Paragraph className="text-name-prd" ellipsis={true}>{item?.product_name} </Paragraph>:
                                    <h6 className="text-title-not-search">見つかりませんでした。</h6>
                                }
                                {
                                    item?.packing_spec? 
                                    <div style={{ flexDirection:'row', display: 'flex', marginTop:-5 }}>
                                        <h6 className="text-name-prd"> 重量:</h6>
                                        <h6 className="text-name-prd2">{ Math.round((item.packing_spec*100) * 100) / 100  + "グラム"}</h6>
                                    </div>:
                                    <h6 className="text-title-not-search1">カテゴリから選んでください！</h6>
                                }
                            </div>
                        </Col>

                        <Col span={4} style={styleCol}>
                            <div style={{ position: 'absolute', top: -2, right: -2}}>
                                <div 
                                    onClick={()=> deleteItemProduct(item, 'IS_SCAN')} 
                                    style={bodyBtn}
                                >
                                    <img src={btn_close} width="50%" height="50%" alt="imageBtnClose"/>
                                </div>
                            </div> 

                            <Space align="end">
                                <Tooltip 
                                    placement="topLeft" 
                                    title={customPop}
                                    color='white'
                                    trigger={"click"}
                                >
                                    <Button 
                                        shape="circle" 
                                        style={buttonStyle} 
                                    >
                                        <h6 
                                            style={{
                                                ...styleText,  
                                                color: '#09D3B7', 
                                                fontWeight: 600
                                            }}>{item.count}</h6> 
                                    </Button>
                                </Tooltip>
                            </Space>
                        </Col>

                    </Row>
                </div>
            </div>
        );
       
    };
    return(
        <Content style={styleContentBody}>
            <h6 className ="text-title"> 取得したバーコード </h6>
            <div style={{ marginTop: 40, paddingBottom:50}} className="list" ref={messageRef}>
                {
                    valueContentScan
                    .reverse()
                    .map((item, index)=> contentBodyListHorizontal(item, index))
                }
            </div> 
        </Content>
    );
};

export default ContentScans;